import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Caret from 'components/Select/caret';
import Heading from 'components/Heading';
import { NotificationCenter } from 'apps/notificationCenter';

import {
  MobileNavViewport,
  ListWrapper,
  RowWrapper,
} from './mobileUserNav.styled';

export default function MobileNotifNav(props) {
  const { show, title } = props;

  useEffect(() => {
    document.querySelector('html').style.overflowY = show
      ? 'hidden'
      : 'initial';
  }, [show]);

  return (
    <MobileNavViewport show={show}>
      <ListWrapper show={show}>
        {title && (
          <RowWrapper parent onClick={props.onClose}>
            <Heading level='4'>{title}</Heading>
            <Caret />
          </RowWrapper>
        )}
        <NotificationCenter isMobile visible={show} />
      </ListWrapper>
    </MobileNavViewport>
  );
}

MobileNotifNav.defaultProps = {
  show: false,
};

MobileNotifNav.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClose: PropTypes.func,
};
